import { Typography, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ScriptOverview = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box>
            <Typography variant="h4" gutterBottom><strong>Scripts</strong></Typography>

            <Typography variant="body1">
                HawkClient supports powerful scripting capabilities that allow you to write custom logic at different levels:
                <ul>
                    <li><strong>Pre-request scripts</strong> – modify requests before they're sent.</li>
                    <li><strong>Post-response scripts</strong> – validate and manipulate responses.</li>
                    <li><strong>Collection-level scripts</strong> – apply logic across multiple requests.</li>
                </ul>
                You can import Node.js modules, use environment variables, and integrate with third-party libraries like <code>faker</code> to generate dynamic test data. Scripts give you full control over the API testing workflow.
            </Typography>
            <img
                src="/scripts/ScriptOverview.png"
                alt="Validations in HawkClient"
                style={{
                    width: isMediumScreen ? '100%' : '60%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                    alignSelf: 'start',
                }}
            />
            <img
                src="/scripts/ScriptTest.png"
                alt="Validations in HawkClient"
                style={{
                    width: isMediumScreen ? '100%' : '60%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                    alignSelf: 'start',
                }}
            />
        </Box>
    )
};

export default ScriptOverview;
